import React from 'react';

/**
 * Basic input that can accept prop with extra class names to change styling.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 * 
 * @todo Is this component the same as Input? Look into this
 */
export const TextInput = ({ name, placeholder, value, onChange, disabled = false, error = false }) => {

    const getClasses = () => {
        let classes = "border border-gray-300 rounded mb-1 min-w-72 max-w-md h-9 p-2 mr-4"
        
        if (error) {
            classes += " border-red-500"
        }
        if (disabled) {
            classes += " cursor-not-allowed bg-gray-200"
        }
        return classes
    }

    return (
        <input 
            type="text"
            name={name}
            value={value}
            onChange={onChange}
            className={getClasses()}
            placeholder={disabled ? null : placeholder}
            disabled={disabled}
        />
    );
};
